import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
  paper: {
    position: 'absolute',
    width: `${50}%`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: 0,
    top: `${40}%`,
    left: `${50}%`,
    right: 'auto',
    bottom: 'auto',
    transform: `translate(-${50}%, -${50}%)`
  },
});

class ConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalIsOpen: nextProps.modalIsOpen
    })
  }


  render() {
    const { customStyles, classes } = this.props;
    const { modalIsOpen } = this.state;
    return (
      <Modal
        open={modalIsOpen}
        onClose={this.props.closeModal} disableBackdropClick={true} disableEscapeKeyDown={true}>
        <div className={classes.paper} >
          <div className="payment-portal-modal">
            <div style={{ textAlign: "center" }}>
              <div className="image-360">
                <div className="image-360-header" style={{ textAlign: "center" }}>Payment Portal</div>
                <div className="image-360-rotation">
                  <Typography>
                    Please refrain from reversing the ACH authorization to avoid the ACH merchant block on your future transactions.
                  </Typography>
                </div>
              </div>
              <Button variant="contained" className="modal-padding" style={{ backgroundColor: '#fa451c' }}
                color="primary" onClick={this.props.closeOnClick}>
                Ok
              </Button>
            </div>
          </div></div>
      </Modal>
    )
  }
};


ConfirmModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ConfirmModal);


// WEBPACK FOOTER //
// ./src/ConfirmModal.js